import { useAuth } from "@/context/auth/AuthContext";
import useMediaAttachment from "@/hooks/useMediaAttachment";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { CroppedImageInput } from "./CroppedImageInput";
import { FormFieldProps } from "./types";

const ImageField = memo(({ config, positionImage }: FormFieldProps) => {
  const { instanceData } = useAuth();
  const { t } = useTranslation();

  const imagePosition = positionImage ?? "";
  const { attachment, previewImageUrl, refetch } = useMediaAttachment(
    imagePosition,
    instanceData?.id,
  );

  return (
    <CroppedImageInput
      docId={instanceData?.id}
      imageURL={previewImageUrl}
      attachment={attachment}
      refetch={refetch}
      imagePosition={imagePosition}
      aspect={2000 / 1500}
      label={t(config.label ?? "image")}
      buildImageName={() => ""}
    />
  );
});

ImageField.displayName = "ImageField";
export default ImageField;
